export default __webpack_public_path__ + "static/media/twitter.8edaab6e.png";